import React, { FC } from 'react';

interface ServiceActionSignProps {
  title: string;
}

const ServiceActionSign: FC<ServiceActionSignProps> = ({ title }) => {
  return (
    <div className="service-card__action-sign">
      <p>{title}</p>
    </div>
  );
};

export default ServiceActionSign;
